// ※ 컨트랙트는 맨 앞 0x 없어야 한다.
export const TRI_CONTRACT = process.env.REACT_APP_TRI_CONTRACT as string;
export const POLYGON_USDT = 'c2132D05D31c914a87C6611C10748AEb04B58e8F' as string;
export const POLYGON_EDOGE = '0AcD96e7b895D534D2216c6Fb5B98fD91Da70C3f' as string;
// 코인 이름 지정
export const COIN_NAME_TRI = 'TRI' as const;
export const COIN_NAME_SFL = 'SFL' as const;
export const COIN_NAME_NFT = 'NFT' as const;
export const COIN_NAME_ETH = 'ETH' as const;
export const COIN_NAME_MATIC = 'MATIC' as const;
export const COIN_NAME_USDT = 'USDT' as const;
export const COIN_NAME_SEPOLIA_ETH = 'SEPOLIA_ETH' as const;
// 체인 번호
export const CHAIN_ID_TAYCAN = 22023 as const; // taycan
export const CHAIN_ID_ETHER = 1 as const; // ether
export const CHAIN_ID_POLYGON = 137 as const; // polygon
export const CHAIN_ID_BNBSMART = 56 as const; // BNB Smart Chain
export const CHAIN_ID_SEPOLIA = 11155111 as const; // BNB Smart Chain

// 코인 타입
export const COIN_TYPE_BASE = 'base' as const;
export const COIN_TYPE_ERC20 = 'erc20' as const;
export const COIN_TYPE_ERC721 = 'erc721' as const;

export const IDTOKEN = 'shuFfle';